export default __webpack_public_path__ + "static/media/pizza_box.0dd9fc63.png";